import Splide from '@splidejs/splide';
import { registerComponent } from '../utils/component-manager.js';
import { logSurveyLink } from '@vimeo/player/src/lib/functions.js';

const SELECTORS = {
    block: '.wp-block-ssm-ranches-feed',
    carousel: '.splide',
    arrows: '.splide__arrows',
    prev: '.splide__arrow--prev',
    next: '.splide__arrow--next',
};

const ROOT_CONTAINER_SELECTOR = '.is-root-container';

const DEFAULT_OPTIONS = {
    perPage: 2.4,
    perMove: 1,
    gap: '1.875rem',
    arrows: false,
    pagination: false,
    rewind: true,
    rewindByDrag: true,
    trimSpace: false,
    focus: 0,
    breakpoints: {
        1500: {
            perPage: 3.4,
        },
        1024: {
            perPage: 2.4,
        },
        800: {
            perPage: 1.5,
            peek: 0,
        },
        520: {
            perPage: 1,
            peek: 0,
        },
    },
};

/**
 * Initialize a single ranches feed slider
 * Used by both frontend ComponentManager and block editor useEffect
 */
export function initRanchesFeed(block) {
    const carousel = block.querySelector(SELECTORS.carousel);
    if (!carousel) return null;

    const options = {
        ...DEFAULT_OPTIONS,
        drag: !block.closest(ROOT_CONTAINER_SELECTOR),
    };

    const splide = new Splide(carousel, options);
    const cleanup = [];

    splide.on('mounted', () => {
        const prev = block.querySelector(SELECTORS.prev);
        const next = block.querySelector(SELECTORS.next);
        const arrows = block.querySelector(SELECTORS.arrows);

        const updateOverflow = () => {
            if (arrows) {
                arrows.style.display = splide.Components.Layout.isOverflow() ? '' : 'none';
            }
        };

        updateOverflow();
        splide.on('resized', updateOverflow);

        if (prev) {
            const handler = () => splide.go('<');
            prev.addEventListener('click', handler);
            cleanup.push(() => prev.removeEventListener('click', handler));
        }

        if (next) {
            const handler = () => splide.go('>');
            next.addEventListener('click', handler);
            cleanup.push(() => next.removeEventListener('click', handler));
        }
    });

    splide.mount();

    const panel = block.closest('.wp-block-ssm-tabs__panel');
    if (panel) {
        const onTabActivated = () => {
            splide.refresh();
        };
        panel.addEventListener('tab:activated', onTabActivated);
        cleanup.push(() => panel.removeEventListener('tab:activated', onTabActivated));
    }

    return {
        destroy() {
            cleanup.forEach((fn) => fn());
            splide.destroy();
        },
    };
}

/**
 * Frontend initialization with FacetWP support
 * This only runs on the frontend, not in the block editor
 */
export function RanchesFeed() {
    registerComponent(SELECTORS.block, {
        trackSelector: SELECTORS.carousel, // Track the .splide element inside
        init: (block) => initRanchesFeed(block),
        destroy: (block, instance) => instance?.destroy(),
    });
}
